var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0542 7.22158H4.87192C4.39037 7.22158 4 7.61195 4 8.0935C4 8.57505 4.39037 8.96543 4.87192 8.96543H24.0542C24.5358 8.96543 24.9262 8.57505 24.9262 8.0935C24.9262 7.61195 24.5358 7.22158 24.0542 7.22158Z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9754 13.325V20.3004C10.9754 20.782 11.3658 21.1723 11.8473 21.1723C12.3289 21.1723 12.7192 20.782 12.7192 20.3004V13.325C12.7192 12.8435 12.3289 12.4531 11.8473 12.4531C11.3658 12.4531 10.9754 12.8435 10.9754 13.325Z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2069 13.325V20.3004C16.2069 20.782 16.5973 21.1723 17.0788 21.1723C17.5604 21.1723 17.9508 20.782 17.9508 20.3004V13.325C17.9508 12.8435 17.5604 12.4531 17.0788 12.4531C16.5973 12.4531 16.2069 12.8435 16.2069 13.325Z",
    fill: "#FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48769 24.66V8.0935C7.48769 7.61195 7.09732 7.22158 6.61577 7.22158C6.13422 7.22158 5.74385 7.61195 5.74385 8.0935V24.66C5.74385 25.3824 6.25461 25.8931 6.25461 25.8931C6.76537 26.4039 7.48769 26.4039 7.48769 26.4039H21.4385C22.1608 26.4039 22.6715 25.8931 22.6715 25.8931C23.1823 25.3824 23.1823 24.66 23.1823 24.66V8.0935C23.1823 7.61195 22.7919 7.22158 22.3104 7.22158C21.8288 7.22158 21.4385 7.61195 21.4385 8.0935V24.66H7.48769Z",
    fill: "#FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99768 4.50003C9.23154 5.26617 9.23154 6.34966 9.23154 6.34966V8.0935C9.23154 8.57505 9.62191 8.96543 10.1035 8.96543C10.585 8.96543 10.9754 8.57505 10.9754 8.0935V6.34966C10.9754 5.98849 11.2308 5.73311 11.2308 5.73311C11.4861 5.47773 11.8473 5.47773 11.8473 5.47773H17.0788C17.44 5.47773 17.6954 5.73311 17.6954 5.73311C17.9508 5.98849 17.9508 6.34966 17.9508 6.34966V8.0935C17.9508 8.57505 18.3411 8.96543 18.8227 8.96543C19.3042 8.96543 19.6946 8.57505 19.6946 8.0935V6.34966C19.6946 5.26617 18.9285 4.50003 18.9285 4.50003C18.1623 3.73389 17.0788 3.73389 17.0788 3.73389H11.8473C10.7638 3.73389 9.99768 4.50003 9.99768 4.50003Z",
    fill: "#FFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.0dc71909199070ff721044225563df7e.svg";
export { ForwardRef as ReactComponent };